import type { IObservableArray } from 'mobx';

import { type Campaign, FILTER_TARGETING_KINDS, type Targeting } from '@feathr/blackbox';

export function validateStepFilters(
  campaign: Campaign,
  targetings: IObservableArray<Targeting>,
): string[] {
  let filterKinds = ['geo'];

  // If the campaign is pixl plus, add age demographic and interest to the filter kinds
  if (campaign.isOmniCampaign) {
    filterKinds = [...FILTER_TARGETING_KINDS];
  }

  const filters = targetings.filter(
    (t) => filterKinds.includes(t.get('kind')) && !t.get('is_archived'),
  );
  if (filters.length === 0) {
    return [];
  }

  return filters
    .map((t) => {
      const errors = t.validate(['target_data', 'kind'], false).errors;
      if (errors.length) {
        return errors[0];
      }
      return undefined;
    })
    .filter((msg) => !!msg) as string[];
}
